import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Link from 'components/common/Link';

import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  root: {
    margin: '16px 0',
    [theme.breakpoints.up('sm')]: {
      margin: '35px 0',
    },
  },
  link: {
    marginLeft: 10,
    lineHeight: pxToEm(24, 16),
  },
});

const ResetPasswordNavigation = ({ classes }) => (
  <Toolbar
    className={classes.root}
    disableGutters
  >
    <Typography variant="subheading">
      Recalled?
    </Typography>
    <Link
      className={classes.link}
      size="lg"
      color="primary"
      bold
      href="/account/login"
      underline
    >
      Log in
    </Link>
  </Toolbar>
);

ResetPasswordNavigation.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(ResetPasswordNavigation);



// WEBPACK FOOTER //
// ./src/components/account/ResetPasswordNavigation/ResetPasswordNavigation.js